module.exports = __webpack_public_path__ + "static/media/Scratch_Before.f6f7393c.jpg";